export default "__VITE_ASSET__Bvyk0i2a__"